export default "__VITE_ASSET__DyN4lZM3__"